/** @jsxImportSource @emotion/react */
import { Grid, Typography } from '@mui/material';
import React from 'react';
import ExpansionGrid from '../../Components/ExpansionGrid';
import { Il8nContext } from '../../Helper/i18n'
import { useContext } from 'react';

function PaymentDetailsReview(props) {
    const { reviewData } = props
    const localeText = useContext(Il8nContext)


    const getAccordianData = () => {
        return <Grid container spacing={3} css={{padding:"10px"}}>
            <Grid container item xs={6} md={3} lg={2} alignItems={"center"} css={{ border: "1px dashed lightgrey" }}>
                <Grid item xs={12}>
                    <Typography variant="body2" css={{ color: "#0098B0" }}>{localeText?.reviewPaymenCompleted}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2" /* color="#333333" fontWeight={"bold"} */ css={{ wordBreak: "break-word" }}>
                        {localeText?.reviewNextBtnYes}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container item xs={6} md={3} lg={2} alignItems={"center"} css={{border:"1px dashed lightgrey"}}>
                <Grid item xs={12}>
                    <Typography variant="body2" css={{color:"#0098B0"}}>{localeText?.reviewPaymentAmount}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2" /* color="#333333" fontWeight={"bold"} */ css={{wordBreak:"break-word"}}>
                        {localeText?.review + reviewData.kycStagingPayment.paymentAmount}
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    }

    return (
        reviewData?.kycStagingPayment ? <ExpansionGrid title={"Payment Details"} accordianData={getAccordianData()} /> : null
    );
}

export default PaymentDetailsReview;